export default "<div class=\"text-center\">\r\n    <div class=\"lds-dual-ring\"></div>\r\n</div>\r\n"